import { render, staticRenderFns } from "./SkillPhaseTable.vue?vue&type=template&id=6ec1007a&scoped=true"
import script from "./SkillPhaseTable.vue?vue&type=script&lang=js"
export * from "./SkillPhaseTable.vue?vue&type=script&lang=js"
import style0 from "./SkillPhaseTable.vue?vue&type=style&index=0&id=6ec1007a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec1007a",
  null
  
)

export default component.exports